var counttime = 0;
function cartNotification(cartId){
  fetch(window.Shopify.routes.root +'?section_id=cart-notification')
  .then((response) => response.text())
  .then((responseText) => {
    const cnID = 'cart-notification';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart_popup');
    const source = html.getElementById(cnID);
    if(source && destination) destination.innerHTML = source.innerHTML;
    let lastItem = document.querySelector(".ch_items .cn_" + cartId).innerHTML;
    if(lastItem) document.querySelector(".ch_items").innerHTML = lastItem;
    if(document.querySelector('.cart-notification')){
      setTimeout(() => { 
        document.querySelector('body').classList.add('open_cart_popup'); 
      }, 1000);
    }
    if(document.querySelector('.combine-product .combine-prod-inr')){
      let html = document.querySelector('.combine-product .combine-prod-inr').innerHTML;
      document.querySelector('.cn-cyl-item').innerHTML = html;
    }
    qty_box();
    counttime = 0;
    const myInterval = setInterval(timer, 1000);
    function timer() {
      counttime++;
      if(counttime > 5){
          document.querySelector('body').classList.remove('open_cart_popup');
          document.querySelector('.cart_popup').innerHTML = '';
        myStop();
      }
    }
    function myStop(){
      clearInterval(myInterval);
    }
  });
}
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if(document.querySelector('.media-grid')){
  var init = false;
  var swiper;
  function swiperCard() {
    if (window.innerWidth <= 991) {
      if (!init) {
        init = true;
        swiper = new Swiper(".media-grid", {
          slidesPerView: "auto",
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            hide: true,
          },
        });
      }
    } else if (init) {
      swiper.destroy();
      init = false;
    }
  }
  swiperCard();
  window.addEventListener("resize", swiperCard);
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
if(document.querySelectorAll('.product-addcart')) document.querySelectorAll('.product-addcart').forEach(function(addToCart){
    addToCart.addEventListener('click',function(evt){
    evt.preventDefault();
    addToCart.classList.add('addingCart');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var cartform = addToCart.closest('form');

    // Blocking cart when custom inventory quantity is enabled in Theme Customizer
    const variantId = cartform.querySelector('input[name="id"]').value;
    const variantSelector = document.querySelector('.product-variant-selector');
    const variantData = JSON.parse(variantSelector.querySelector('[type="application/json"]').textContent);
    const variantName = variantData.find(v => v.id === parseInt(variantId, 10))?.name || 'this product';
    const variantWrapper = variantSelector.querySelector(`.variant-wrapper[data-variant-id="${variantId}"]`);
    const variantInventory = variantWrapper ? parseInt(variantWrapper.getAttribute('data-inventory'), 10) : 0;
    const variantStockThreshold = variantWrapper ? parseInt(variantWrapper.getAttribute('data-threshold'), 10) || null : null;
    if (variantInventory < variantStockThreshold) { 
      document.querySelector('.product-form-error').innerHTML = `The product "${variantName}" is already sold out`;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
        addToCart.classList.remove('addingCart');
        },2000);
      return;
    }

    const formData = new FormData(cartform);  
    
    // Add a unique property to ensure a new line is created
    // const uniqueValue = `${Date.now()}:${Math.random().toString(36).substring(2, 15)}`;
    const uniqueValue = `product:${Date.now()}:${Math.random().toString(36).substring(2, 15)}`
    formData.append('properties[_unique]', uniqueValue);

    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
          addToCart.classList.remove('addingCart');
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          cartNotification(response.id);
          load_cart();
          setTimeout(function(e){
            addToCart.classList.remove('addingCart');
          },1000);
          setTimeout(function(e){
            // document.querySelector('body').classList.add('open-drawer');
          },1010);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
  });
});
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.snippet-sticky-product-cart .choose-selector a')) document.querySelector('.snippet-sticky-product-cart .choose-selector a').addEventListener('click',function(e){
  e.preventDefault();
  if(window.outerWidth > 991){
    setTimeout(() => {window.scrollTo(0, 0);}, 400);
  }else{
    window.scrollTo(0, document.querySelector('.product-variant-selector').offsetTop - document.querySelector('header').clientHeight - 10);
  }
})
if(document.querySelectorAll('.prod-more-color span')) document.querySelectorAll('.prod-more-color span').forEach(function(moreColor){
  moreColor.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.product-color-selector').classList.add('show-all-color');
  });
});
if(document.querySelector('.prod-less-color span')) document.querySelector('.prod-less-color span').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('.product-color-selector').classList.remove('show-all-color');
})
document.addEventListener("DOMContentLoaded", (event) => {
  let colorScroll = document.querySelector('.product-color-selector ul');
  colorScroll.addEventListener('scroll', () => {
    let scrollLeft = colorScroll.scrollLeft;
    let scrollWidth = colorScroll.scrollWidth;
    let clientWidth = colorScroll.clientWidth;
    if(scrollLeft > 0){
      colorScroll.classList.add('scrolled');
    }else{
      colorScroll.classList.remove('scrolled');
    }
    if(scrollLeft + clientWidth >= scrollWidth){
      colorScroll.classList.add('end-reached');
    }else{
      colorScroll.classList.remove('end-reached');
    }
  });
  document.querySelectorAll('.grid-meta-color li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      if(window.innerWidth > 991){
        if(color.querySelector('a') != null && document.querySelector('.color-name') != null){
          let colorName = color.querySelector('a').getAttribute('data-val')
          document.querySelector('.color-name').textContent = colorName
        }
      }
    })
    color.addEventListener('mouseout',function(){
      if(window.innerWidth > 991){
        if(color.querySelector('a') != null && document.querySelector('.color-name') != null){
          document.querySelector('.color-name').textContent = document.querySelector('.grid-meta-color li.active a').getAttribute('data-val')
        }
      }
    })
  })
  if(document.querySelector('.size_btn a')) document.querySelector('.size_btn a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('open-size');
  })
  if(document.querySelector('.sg-close')) document.querySelector('.sg-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-size');
  })
  document.querySelectorAll('.sg-table-switch a').forEach(function(size_switch){
    size_switch.addEventListener('click', function(e){
      e.preventDefault();
      let selectedUnit = size_switch.getAttribute('data-val').toLowerCase();
      document.querySelectorAll('.sg-table-switch a').forEach(function(size_switch_rm){
        size_switch_rm.classList.remove('active');
      });
      size_switch.classList.add('active');
      updateTable(selectedUnit);
    });
  });
  function updateTable(unit){
    let conversionFactor = 2.54;
    let rows = document.querySelectorAll('.sg-table tbody tr');
    rows.forEach(function(row) {
      let cells = row.querySelectorAll('td');
      for(let i = 1; i < cells.length; i++){
        let value = parseFloat(cells[i].getAttribute('data-cm')) || parseFloat(cells[i].textContent);
        if(unit === 'inches'){
          value = (value / conversionFactor).toFixed(2);
        }else{
          value = value.toFixed(2);
        }
        if(parseFloat(value) === Math.floor(value)){
          value = Math.floor(value);
        }
        cells[i].textContent = value;
      }
    });
  }
  document.querySelectorAll('.sg-table tbody tr').forEach(function(row){
    let cells = row.querySelectorAll('td');
    for(let i = 1; i < cells.length; i++){
      let cmValue = parseFloat(cells[i].textContent.replace(',', '.'));
      cells[i].setAttribute('data-cm', cmValue);
    }
  });
  if(document.querySelectorAll('.prod-match-icon li')) document.querySelectorAll('.prod-match-icon li').forEach(function(matchIcon){
    matchIcon.addEventListener('click',function(e){
      e.preventDefault();
      let active_icon = matchIcon.getAttribute('data-val');
      document.querySelectorAll('.prod-match-icon li').forEach(function(removeMatchIcon){
        removeMatchIcon.classList.remove('active-icon');
      });
      document.querySelectorAll('.prod-match-text li').forEach(function(matchText){
        let all_text = matchText.getAttribute('data-val');
        if(all_text == active_icon){
          matchText.classList.add('active-text');
        }else{
          matchText.classList.remove('active-text');
        }
      });
      matchIcon.classList.add('active-icon');
    });
  });
  // if(document.querySelectorAll('.prod-tab-head li')) document.querySelectorAll('.prod-tab-head li').forEach((tabTitle) => {
  //   tabTitle.addEventListener('click',function(e){
  //     e.preventDefault();
  //     document.querySelectorAll('.prod-tab-head li').forEach((tabTitle) => {
  //       tabTitle.classList.remove('active-title');
  //     })
  //     tabTitle.classList.add('active-title');
  //     let val = tabTitle.getAttribute('data-val');
  //     document.querySelectorAll('.prod-tab-cont li').forEach((tabContent) => {
  //       let allVal = tabContent.getAttribute('data-val');
  //       if(val == allVal){
  //         document.querySelectorAll('.prod-tab-cont li').forEach((tabContent) => {
  //           tabContent.classList.remove('active-cont');
  //         })
  //         tabContent.classList.add('active-cont');
  //       }
  //     })
  //   })
  // })
  if (document.querySelectorAll('.prod-tab-head li')) {
    document.querySelectorAll('.prod-tab-head li').forEach((tabTitle) => {
      tabTitle.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.prod-tab-head li').forEach((tabTitle) => {
          tabTitle.classList.remove('active-title');
        });
        tabTitle.classList.add('active-title');
        let val = tabTitle.getAttribute('data-val');
        document.querySelectorAll('.prod-tab-cont li').forEach((tabContent) => {
          tabContent.classList.remove('active-cont');
          if (tabContent.getAttribute('data-val') === val) {
            tabContent.classList.add('active-cont');
          }
        });
        const tabContents = document.querySelectorAll('.prod-tab-cont li');
        let maxHeight = 0;
        tabContents.forEach((content) => {
          const contentHeight = content.offsetHeight;
          if (contentHeight > maxHeight) {
            maxHeight = contentHeight;
          }
        });
        const tabContainer = document.querySelector('.prod-tab-cont');
        if (tabContainer) {
          tabContainer.style.height = `${maxHeight}px`;
        }
      });
    });
  }
});
window.addEventListener('scroll', function(){
  var div = document.querySelector('.snippet-addto-cart');
  var body = document.body;
  var rect = div.getBoundingClientRect();
  var topOffset = rect.top;
  if(topOffset <= 0){
    var sectionFooter = document.querySelector('.section-footer');
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
    var Buttons = document.querySelectorAll('.snippet-sticky-product-cart');
    Buttons.forEach(function(button){
      if(section < 0){
        document.querySelector('body').classList.remove('stickybar');
      } else {
        document.querySelector('body').classList.add('stickybar');
      }
    });
  }else{
    document.querySelector('body').classList.remove('stickybar');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.stapelkorting-close-button');
  const stapelkortingProductPage = document.getElementById('stapelkorting-product-page');

  if (closeButton && stapelkortingProductPage) {
    closeButton.addEventListener('click', function() {
      stapelkortingProductPage.style.display = 'none';
    });
  }
});